var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsupPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.00008C17.875 7.00008 18.2188 7.15286 18.5312 7.45842C18.8438 7.76397 19 8.11119 19 8.50008V9.68758C19 9.79869 18.9896 9.89939 18.9688 9.98967C18.9479 10.0799 18.9167 10.1737 18.875 10.2709L16.3958 16.0834C16.2847 16.3612 16.1042 16.5834 15.8542 16.7501C15.6042 16.9167 15.3194 17.0001 15 17.0001H7C6.58333 17.0001 6.22917 16.8577 5.9375 16.573C5.64583 16.2883 5.5 15.9306 5.5 15.5001V7.62508C5.5 7.41675 5.54167 7.21883 5.625 7.03133C5.70833 6.84383 5.81944 6.68064 5.95833 6.54175L10.1458 2.35425C10.3958 2.10425 10.7014 1.94453 11.0625 1.87508C11.4236 1.80564 11.7292 1.8473 11.9792 2.00008C12.2986 2.18064 12.5035 2.44453 12.5938 2.79175C12.684 3.13897 12.6944 3.47925 12.625 3.81258L12 7.00008H17.5ZM2.5 17.0001C2.09722 17.0001 1.74653 16.8508 1.44792 16.5522C1.14931 16.2536 1 15.9029 1 15.5001V8.50008C1 8.0973 1.14931 7.74661 1.44792 7.448C1.74653 7.14939 2.09722 7.00008 2.5 7.00008C2.90278 7.00008 3.25347 7.14939 3.55208 7.448C3.85069 7.74661 4 8.0973 4 8.50008V15.5001C4 15.9029 3.85069 16.2536 3.55208 16.5522C3.25347 16.8508 2.90278 17.0001 2.5 17.0001Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupPrimary);
export default __webpack_public_path__ + "static/media/thumbsup-primary.ca28d9e4271b84025b52e3a3f0ba95bb.svg";
export { ForwardRef as ReactComponent };